import { Component, Injector, Input, OnInit, forwardRef } from '@angular/core'
import { FormBuilder, UntypedFormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms'
import { FormGroupValueAccessorDirective } from '@se-po/shared-ui-form-directives'
import { SeFeTranslationsLoader } from 'se-fe-translations'
import { Persona } from 'se-resource-types/dist/lib/UserService'

@Component({
  selector: 'se-po-child-contact-info',
  templateUrl: './child-contact-info.component.html',
  styleUrls: ['./child-contact-info.component.scss'],
  providers:[
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ChildContactInfoComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ChildContactInfoComponent),
      multi: true,
    }
  ],
  standalone: false,
})
export class ChildContactInfoComponent extends FormGroupValueAccessorDirective implements OnInit {
  public form: UntypedFormGroup
  public firstLastName: string
  public showEmail: boolean
  public showPhone: boolean

  private _persona: Persona

  constructor(
    protected injector: Injector,
    private formBuilder: FormBuilder,
    private seFeTranslationsLoader: SeFeTranslationsLoader
  ) {
    super(injector)
  }

  public get persona(): Persona {
    return this._persona
  }

  @Input() public set persona(persona: Persona) {
    this._persona = persona
    this.firstLastName = persona.first_name + ' ' + persona.last_name
  }

  public ngOnInit(): void {
    super.ngOnInit()
    this.initTranslations()
  }

  public initForm(): void {
    this.form = this.formBuilder.group({
      email: [''],
      phone: ['']
    })
  }

  public setForm(value: any): void {
    this.form.setValue({
      email: value?.email || '',
      phone: value?.phone || ''
    })
    this.showEmail = !!value?.email
    this.showPhone = !!value?.phone
  }

  public initTranslations(): void {
    this.seFeTranslationsLoader.load('shared/ui-child-contact-info/assets/translations').then(() => {
      this.loaded = true
    })
  }
}
